import React from 'react';

export const Minus = () => (
    <line x1='5' y1='12' x2='19' y2='12' />
);